<template>
<div>

<Mail></Mail>
</div>
</template>

<script>
import Mail from "../../components/Applicant/Mail.vue";



export default {

  components: {
   Mail
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {

  }
};
</script>

<style scoped>


                       
</style>